import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Airnote, DeleteAirnoteRequest, GetAirnoteRequest, PatchAirnoteTextRequest, PostAirnoteRequest} from '../models/airnote';
import {Simple200Response} from '../models/general';
import {map} from 'rxjs/internal/operators';

@Injectable()
export class AirnoteService {

  constructor(private httpClient: HttpClient) {
  }

  getAirnote({organizationToken, fromDate, toDate, deviceUuid}: GetAirnoteRequest): Observable<Airnote[]> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/org/airnotes`;
    const params = {
      deviceUuid,
      from: fromDate.toISOString(),
      to: toDate.toISOString()
    };

    return this.httpClient
      .get<{ airnotes: Airnote[] }>(url, {headers, params})
      .pipe(
        map((response: { airnotes: Airnote[] }) => response.airnotes)
      );
  }

  postAirnote({organizationToken, deviceType, deviceId, date, component, value, text, labels = []}: PostAirnoteRequest):
    Observable<Airnote> {

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${organizationToken}`,
      'Content-Type': 'application/json'
    });
    const url: string = `${environment.afbV2Host}org-users/self/org/airnotes`;
    const body = {
      deviceType,
      deviceId,
      text,
      component,
      value,
      labels,
      timestamp: date.toISOString()
    };

    return this.httpClient
      .post<Airnote>(url, body, {headers});
  }

  patchAirnoteText({organizationToken, airnoteId, text}: PatchAirnoteTextRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${organizationToken}`,
      'Content-Type': 'application/json'
    });
    const url: string = `${environment.afbV2Host}org-users/self/org/airnotes/${airnoteId}/text`;
    const body = {text};

    return this.httpClient
      .patch<Simple200Response>(url, body, {headers});
  }

  deleteAirnote({organizationToken, airnoteId}: DeleteAirnoteRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/org/airnotes/${airnoteId}`;

    return this.httpClient
      .delete<Simple200Response>(url, {headers});
  }
}
